import { Separator as SeparatorPrimitive } from 'radix-ui';
import { cn } from '../../lib/utils';
import type { SeparatorProps } from './types';

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: SeparatorProps) {
  return (
    <SeparatorPrimitive.Root
      data-slot='separator'
      decorative={decorative}
      orientation={orientation}
      className={cn(
        'eye:shrink-0 eye:bg-grey-40 eye:data-[orientation=horizontal]:h-px eye:data-[orientation=horizontal]:w-full eye:data-[orientation=vertical]:h-full eye:data-[orientation=vertical]:w-px',
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
